
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { LogService } from '@oa/shared-core';

declare var window: any;

@Injectable()
export class HelpService {
  private readonly _serviceName = 'HelpService';
  private _disabled: boolean = false;

  baseUrl = 'help/questions';

  /**
   * Is verbose logging enabled
   */
  private get verboseLogging(): boolean {
    // return true;
    return this.log.verboseLogging;
  }

  public get disabled(): boolean {
    return this._disabled;
  }
  public set disabled(v: boolean) {
    if (this.verboseLogging) {
      console.log(`${this._serviceName}.disabled v=`, v);
    }

    this._disabled = v;
  }

  constructor(
    @Inject(DOCUMENT) readonly document: any,
    private http: HttpClient,
    private cookieService: CookieService,
    private log: LogService
  ) {}

  getQuestions() {
    const mockQuestionsUrl = 'assets/mock-data/help-questions.json';
    return this.http.get(mockQuestionsUrl);
  }

  search(term: string) {
    const requestUrl = this.baseUrl + '?query=' + JSON.stringify({ expression: term });

    return this.http.get(requestUrl);
  }

  private setOAChatButtonCookie(b: boolean) {
    if (this.verboseLogging) {
      console.log(`${this._serviceName}.setOAChatButtonCookie(b) b=${b}`);
    }

    this.cookieService.set('oa-chat-button-visible', String(b), 1, null, null, false, 'Lax');
  }
}
